export function Badge({ type = 'success', title }) {
  return (
    <div className="card__badges">
      <div className={`badge badge--tiny badge--${type}`}>{title}</div>
    </div>
  );
}
